export const DocumentNumberTooltipImages = {
  'DOCUMENT_PASSPORT': '/images/tooltips/passport/number.jpg',
  'DOCUMENT_ID_CARD': '/images/tooltips/card/number.png',
  'DOCUMENT_DRIVERS_LICENSE': '/images/tooltips/driver/number.jpg',
  'DOCUMENT_EXTERNAL_PASSPORT': '/images/tooltips/international/number.jpg',
  'DOCUMENT_RESIDENCE_PERMIT': '/images/tooltips/residence/number.jpg',
};

export const DocumentSeriesTooltipImages = {
  'DOCUMENT_PASSPORT': '/images/tooltips/passport/code.jpg',
  'DOCUMENT_ID_CARD': '/images/tooltips/card/code.png',
  'DOCUMENT_DRIVERS_LICENSE': '/images/tooltips/driver/code.jpg',
  'DOCUMENT_EXTERNAL_PASSPORT': '/images/tooltips/international/code.jpg',
  'DOCUMENT_RESIDENCE_PERMIT': '/images/tooltips/residence/code.jpg',
};

export const DocumentIssueDateTooltipImages = {
  'DOCUMENT_PASSPORT': '/images/tooltips/passport/date.jpg',
  'DOCUMENT_ID_CARD': '/images/tooltips/card/date.png',
  'DOCUMENT_DRIVERS_LICENSE': '/images/tooltips/driver/date.png',
  'DOCUMENT_EXTERNAL_PASSPORT': '/images/tooltips/international/date.jpg',
  'DOCUMENT_RESIDENCE_PERMIT': '/images/tooltips/residence/date.jpg',
};

export const DocumentIssueEndDateTooltipImages = {
  'DOCUMENT_PASSPORT': '/images/tooltips/passport/date.jpg',
  'DOCUMENT_ID_CARD': '/images/tooltips/card/date.png',
  'DOCUMENT_DRIVERS_LICENSE': '/images/tooltips/driver/date.png',
  'DOCUMENT_EXTERNAL_PASSPORT': '/images/tooltips/international/end-date.jpg',
  'DOCUMENT_RESIDENCE_PERMIT': '/images/tooltips/residence/date.jpg',
};

export const DocumentIssuedByTooltipImages = {
  'DOCUMENT_PASSPORT': '/images/tooltips/passport/issue.jpg',
  'DOCUMENT_ID_CARD': '/images/tooltips/card/issue.png',
  'DOCUMENT_DRIVERS_LICENSE': '/images/tooltips/driver/issue.png',
  'DOCUMENT_EXTERNAL_PASSPORT': '/images/tooltips/international/issue.jpg',
  'DOCUMENT_RESIDENCE_PERMIT': '/images/tooltips/residence/issue.jpg',
};
